import { CardLoader } from '@betterment/shared-components/src/components/card-loader/card-loader';

import { UserBalancePerformanceQuery } from './graphql/userPerformanceBalance.generated';

export type BalanceDetailsProps = {
  totals: UserBalancePerformanceQuery['performance']['totals'] | undefined;
  startDate?: Date;
  endDate?: Date;
  id: string;
};

export const BalanceDetails: React.FC<BalanceDetailsProps> = ({ totals, startDate, endDate, id }) => {
  if (!totals) {
    return <CardLoader />;
  }

  return (
    <div id={id}>
      {totals && `Totals: ${totals.earned.cents}`}
      {startDate && ` Start: ${startDate.toISOString()}`}
      {endDate && ` End: ${endDate.toISOString()}`}
    </div>
  );
};
